export function Avatar({ name = '?', src, size = 'md', status, className = '' }) {
  const sizes = { sm: 'size-8 text-[10px]', md: 'size-10 text-xs', lg: 'size-12 text-sm' };
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
  return <span className={`relative inline-grid shrink-0 place-items-center border border-white/10 bg-[#101923] font-bold tracking-[.08em] text-cyan-100 ${sizes[size]} ${className}`}>
    {src ? <img src={src} alt="" className="size-full object-cover"/> : initials}
    {status && <span className={`absolute -bottom-0.5 -right-0.5 size-2.5 border-2 border-[#0a1017] ${status === 'online' ? 'bg-emerald-400' : status === 'busy' ? 'bg-amber-400' : 'bg-slate-500'}`}/>} 
  </span>;
}
